module.exports = __webpack_public_path__ + "img/beer_id-89.37d218f6.png";